import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {publishCount, publishTime} from "../MetricUtility";
import {ERROR_METRIC_SUFFFIX} from "../constants";

const metricProcessName = "SCC_STOW";
const metricName = "getReverseSortGroupPlan";

/**
 * Error type constants for classifying API errors.
 */
export const ErrorType = {
    VALIDATION: "VALIDATION",
    RETRYABLE: "RETRYABLE",
    NON_RETRYABLE: "NON_RETRYABLE"
};

/**
 * Classifies an API error response into a typed error object.
 *
 * @param {object} response - The API Gateway response
 * @returns {{ type: string, message: string }} Classified error
 */
export function classifyError(response) {
    const status = response && response.status;
    const data = response && response.data;

    if (status === 400) {
        return {
            type: ErrorType.VALIDATION,
            message: (data && data.message) || "Invalid request parameters."
        };
    }

    if (status === 500) {
        const isRetryable = data && data.retryable === true;
        if (isRetryable) {
            return {
                type: ErrorType.RETRYABLE,
                message: (data && data.message) || "A retryable error occurred. Please try again."
            };
        }
        return {
            type: ErrorType.NON_RETRYABLE,
            message: (data && data.message) || "An unexpected error occurred."
        };
    }

    // Default to non-retryable for any other unexpected status
    return {
        type: ErrorType.NON_RETRYABLE,
        message: (data && data.message) || "An unexpected error occurred."
    };
}

/**
 * Fetches the reverse sort group plan for a given station.
 *
 * @param {object} request - The request payload, e.g. { nodeId: "DIG1" }
 * @returns {Promise<{ planDay: string|null, sortGroupPlans: Array }>} The plan data
 * @throws {{ type: string, message: string }} Classified error on non-200 responses
 */
export async function getReverseSortGroupPlan(request) {
    const args = {
        resourcePath: "svs/containerPlan",
        httpMethod: "post",
        processName: "stow",
        requestBody: request
    };

    const startTime = Date.now();
    const response = await getAPIGatewayDataFromParent(args);

    if (response.status === 200) {
        publishTime(metricProcessName, metricName, startTime);
        return {
            planDay: response.data.planDay,
            sortGroupPlans: response.data.sortGroupPlans
        };
    }

    publishCount(metricProcessName, metricName + ERROR_METRIC_SUFFFIX);
    throw classifyError(response);
}



// WEBPACK FOOTER //
// ./src/resources/ReverseSortGroupPlanResource.js